export const APP_TYPE = "OUTSIDE_ADMIN";
export const APP_TYPES = {
  INSIDE_ADMIN: "INSIDE_ADMIN",
  OUTSIDE_ADMIN: "OUTSIDE_ADMIN",
  ADMIN: "ADMIN",
  ALL: "ALL" // for dev purpose
}
export const APP_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS";
// export const APP_AUTH_MODE = "API_KEY"